import { Webhook } from '../../domain/webhook/Webhook';
import { WebhookActionType, WebhookActions } from './actions';

export interface WebhookState {
  webhooks?: Webhook[];
}

export const getInitialState = (): WebhookState => ({
  webhooks: undefined,
});

export const WebhookReducer = (state: WebhookState, action: WebhookActions): WebhookState => {
  switch (action.type) {
    case WebhookActionType.FETCH_WEBHOOKS_SUCCESS:
    case WebhookActionType.UPDATE_WEBHOOK_SUCCESS:
      return {
        ...state,
        webhooks: action.payload.webhooks,
      };
    case WebhookActionType.DELETE_WEBHOOK_SUCCESS:
      return {
        ...state,
        webhooks: state.webhooks?.filter((webhook) => webhook.id !== action.payload.webhook.id),
      };
    default:
      return state;
  }
};
